import { Injectable }               from '@angular/core';
import { HttpClient, HttpParams}    from '@angular/common/http';
import { map, timeout }             from 'rxjs/operators';
import { BaseService }              from './base.service';


@Injectable({
  providedIn: 'root'
})

export class BackendService extends BaseService {

  constructor(private httpClient: HttpClient) {
    super();
  }

  getSoftwareSettings(callback_function = undefined)
  {
    return this.httpClient.get<any>(this.base_server_url + this.server_urls["settings"]).pipe(timeout(5000)).pipe(map((response: any) => response));
  }

}
